module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page delete-page"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Live Video")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-3"
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Your channel is being deleted...")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n      This process can take up to 5 minutes. When this process is completed,\n      you can create a new channel"), _c('br'), _vm._v("\n      This page should automatically refresh.\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-3 mt-3",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.getStream()
      }
    }
  }, [_vm._v("Refresh")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4193c8ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/delete.vue
// module id = 1696
// module chunks = 180